// @ts-nocheck
export const localeCodes =  [
  "en-US"
]
export const localeLoaders = {
  "en-US": [
    {
      key: "locale_get_45language_46ts_2c09437b",
      load: () => import("#nuxt-i18n/2c09437b" /* webpackChunkName: "locale_get_45language_46ts_2c09437b" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    name: "English (United States) (en-US)",
    code: "en-US",
    iso: "en-US",
    language: "en-US",
    _hreflang: "en-US",
    _sitemap: "en-US"
  }
]
/** client **/

/** client-end **/